import { render, staticRenderFns } from "./VeilLab.vue?vue&type=template&id=5cee34b6&scoped=true"
import script from "./VeilLab.vue?vue&type=script&lang=js"
export * from "./VeilLab.vue?vue&type=script&lang=js"
import style0 from "./VeilLab.vue?vue&type=style&index=0&id=5cee34b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cee34b6",
  null
  
)

export default component.exports